import { RootState } from "../../store";
import { createSelector } from "@reduxjs/toolkit";
import { IUserState } from "../../interfaces/state";

export const selectUserLogin = (state: RootState): IUserState => state.userLogin;

export const selectUserToken = createSelector([selectUserLogin], (user) => user.userData?.token);
export const selectUser = createSelector([selectUserLogin], (user) => user.userData?.user);